// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__azGBJ","heading":"Projects_heading__VnfOW","cards":"Projects_cards__fMCL2"};